var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexSwatch = function SvgHexSwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.836,
    cy: 12.66,
    r: 12,
    fill: "url(#hex-swatch_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hex-swatch_svg__a",
    x1: 12.836,
    x2: 12.836,
    y1: 0.66,
    y2: 24.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC40D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#924058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#560847"
  })))));
};
export default SvgHexSwatch;